import React, { useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './PopupToggler.module.scss';
import cn from 'classnames';
import { isFunction } from 'lodash';
import useOnClickOutside from '../../../hooks/useOnClickOutside';
import { InfoTitle } from '../../common/InfoTooltip';

export function PopupToggler(props) {
  const {
    trigger,
    onTriggerClick,
    icon,
    info,
    title,
    children,
    alignment = 'left',
    disabled = false,
    wide = false,
  } = props;

  const wrapperRef = useRef();
  const [opened, setOpened] = useState(false);

  useOnClickOutside(
    wrapperRef,
    useCallback(() => {
      setOpened(false);
      onTriggerClick && onTriggerClick(false);
    }, [onTriggerClick]),
  );

  const togglePopup = () => {
    if (!disabled) {
      setOpened((opened) => !opened);
      onTriggerClick && onTriggerClick(!opened);
    }
  };

  return (
    <div ref={wrapperRef}>
      <InfoTitle content={info} disabled={!info}>
        <div className={cn(styles.popupToggler, disabled ? styles.disabled : '')}>
          <button type="button" className={styles.button} onClick={togglePopup}>
            {trigger || icon}
          </button>

          <div className={cn(styles.popup, styles[`alignment-${alignment}`], wide ? styles.wide : '')} hidden={!opened}>
            {title && <h5>{title}</h5>}
            <div className={styles.popupBody}>{isFunction(children) ? children(togglePopup) : children}</div>
          </div>
        </div>
      </InfoTitle>
    </div>
  );
}

PopupToggler.propTypes = {
  wide: PropTypes.bool,
  icon: PropTypes.node,
  info: PropTypes.string,
  title: PropTypes.string,
  trigger: PropTypes.node,
  disabled: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  alignment: PropTypes.oneOf(['left', 'right']),
  onTriggerClick: PropTypes.func,
};
